export const abbreviateLabel = (label: string, maxLength = 15): string => {
  if (label.length <= maxLength) return label;
  let slice = label.slice(0, maxLength);
  slice = slice + "...";
  return slice;
};

